import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-54780d70")
const _hoisted_1 = { class: "lbp-review-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Pool Name", -1)
const _hoisted_3 = { class: "text-xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Pool Symbol", -1)
const _hoisted_5 = { class: "text-xl" }
const _hoisted_6 = { class: "lbp-review-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Start Date & Time", -1)
const _hoisted_8 = { class: "text-xl" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "End Date & Time", -1)
const _hoisted_10 = { class: "text-xl" }
const _hoisted_11 = { class: "lbp-review-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Trading Fee", -1)
const _hoisted_13 = { class: "text-xl" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Platform Fee"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xl" }, "2%")
], -1)
const _hoisted_15 = { class: "lbp-review-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Fair Launch Token", -1)
const _hoisted_17 = { class: "text-xl items-center flex" }
const _hoisted_18 = { class: "mr-2" }
const _hoisted_19 = { class: "mr-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Collateral Token", -1)
const _hoisted_21 = { class: "text-xl items-center flex" }
const _hoisted_22 = { class: "mr-2" }
const _hoisted_23 = { class: "mr-1" }
const _hoisted_24 = { class: "lbp-review-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Start Weights", -1)
const _hoisted_26 = { class: "text-xl items-center flex" }
const _hoisted_27 = { class: "mr-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1)
const _hoisted_29 = { class: "mr-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "End Weights", -1)
const _hoisted_31 = { class: "text-xl items-center flex" }
const _hoisted_32 = { class: "mr-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1)
const _hoisted_34 = { class: "mr-1" }
_popScopeId()

import useLgeCreateState from '@/embr/lbp/composables/useLgeCreateState';
import BalTextInput from '@/components/_global/BalTextInput/BalTextInput.vue';
import PoolCreateTokenRow from '@/embr/components/pages/pool-create/PoolCreateTokenRow.vue';
import useWeb3 from '@/services/web3/useWeb3';
import useTokenLists from '@/composables/useTokenLists';
import useTokens from '@/composables/useTokens';
import { computed } from 'vue';
import { getAddress } from '@ethersproject/address';
import LbpTokenWeightsConfig from '@/embr/lbp/components/LbpTokenWeightsConfig.vue';
import { isGreaterThanOrEqualTo } from '@/embr/utils/validations';
import { isLessThanOrEqualTo } from '@/lib/utils/validations';


export default _defineComponent({
  setup(__props) {

const {
  data,
  tokenRequiresApproval,
  collateralTokenRequiresApproval
} = useLgeCreateState();
const { getToken } = useTokens();

const launchToken = computed(() => getToken(data.value.tokenContractAddress));
const collateralToken = computed(() =>
  getToken(data.value.collateralTokenAddress)
);

const { appNetworkConfig } = useWeb3();
const { tokenListsLoaded } = useTokenLists();

const allowedCollateralTokens = computed(() => [
  getAddress(appNetworkConfig.addresses.weth),
  getAddress(appNetworkConfig.addresses.usdc)
]);

const tokensLoaded = computed(() => {
  return tokenListsLoaded.value;
});

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).poolName), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, "BPT-" + _toDisplayString(_unref(data).poolSymbol), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(data).startDate) + " " + _toDisplayString(_unref(data).startTime) + " UTC", 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(data).endDate) + " " + _toDisplayString(_unref(data).endTime) + " UTC", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", null, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(data).swapFeePercentage) + "%", 1)
      ]),
      _hoisted_14
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", null, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(data).tokenAmount), 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(launchToken).symbol), 1),
          _createVNode(_component_BalAsset, {
            address: _unref(launchToken).address,
            iconURI: _unref(data).tokenIconUrl
          }, null, 8, ["address", "iconURI"])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(data).collateralAmount), 1),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(collateralToken).symbol), 1),
          _createVNode(_component_BalAsset, {
            address: _unref(collateralToken).address
          }, null, 8, ["address"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", null, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(data).tokenStartWeight) + "%", 1),
          _createVNode(_component_BalAsset, {
            address: _unref(launchToken).address,
            iconURI: _unref(data).tokenIconUrl
          }, null, 8, ["address", "iconURI"]),
          _hoisted_28,
          _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(data).collateralStartWeight) + "%", 1),
          _createVNode(_component_BalAsset, {
            address: _unref(collateralToken).address
          }, null, 8, ["address"])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(data).tokenEndWeight) + "%", 1),
          _createVNode(_component_BalAsset, {
            address: _unref(launchToken).address,
            iconURI: _unref(data).tokenIconUrl
          }, null, 8, ["address", "iconURI"]),
          _hoisted_33,
          _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(data).collateralEndWeight) + "%", 1),
          _createVNode(_component_BalAsset, {
            address: _unref(collateralToken).address
          }, null, 8, ["address"])
        ])
      ])
    ])
  ], 64))
}
}

})